import {
  RichTextField,
  SimpleShowLayout,
  TextField,
  Show,
} from "react-admin";
export default function MusicShow(props) {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="url" />
        <RichTextField source="description" />
      </SimpleShowLayout>
    </Show>
  );
}
